import {StateProvider} from "@uirouter/angularjs";
import {TradeSimulationService} from "./service/TradeSimulationService";
import {ExpiryService} from "../services/expiry/ExpiryService";
import {HolidayService} from "../services/holiday/HolidayService";
import {TradeSimulatorViewStoreFactory} from "./service/TradeSimulatorViewStoreFactory";
import {FeatureNames} from "../types/UserConfig";
import {Milestone} from "../services/milestone/MilestoneService";
import {MilestoneStore} from "../services/milestone/MilestoneStore";
import {IModalService} from "angular-ui-bootstrap";
import {CurrentUserService} from "../services/user/CurrentUserService";
import {AnalyticsService} from "../analytics/services/AnalyticsService";
import {AnalyticsType} from "../analytics/models/AnalyticsType";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider) {

    $stateProvider.state("simulation", {
        url: "/simulation",
        redirectTo: "backtesting"
    });

    $stateProvider.state("backtesting", {
        url: "/backtesting",
        component: "tfTradeSimulator",
        resolve: {
            viewStore: viewStoreResolver
        },
        data: {
            pageTitle: "Trading Simulator"
        },
        onEnter: routeEntered
    });
}

/** @ngInject */
export async function viewStoreResolver(expiryService: ExpiryService,
                                        holidayService: HolidayService,
                                        tradeSimulationService: TradeSimulationService,
                                        tradeSimulatorViewStoreFactory: TradeSimulatorViewStoreFactory) {
    const expiriesRequest = expiryService.get("ASX");
    const holidaysRequest = holidayService.get("ASX");
    const requests: Array<Promise<any>> = [expiriesRequest, holidaysRequest];
    const [expiries, holidays] = await Promise.all(requests);
    const service = tradeSimulatorViewStoreFactory.create(expiries, holidays);

    return new Promise((resolve) => {
        service.simulations
               .take(1)
               .subscribe(() => resolve(service));
    });
}

/** @ngInject */
export async function routeEntered(milestoneStore: MilestoneStore,
                                   $uibModal: IModalService,
                                   currentUserService: CurrentUserService,
                                   analyticsService: AnalyticsService): Promise<boolean> {
    if (!currentUserService.hasFeature(FeatureNames.SCREEN_BACKTESTING)) {
        return false;
    }
    const acceptedDisclaimer = await ensureDisclaimerAccepted(milestoneStore, $uibModal);

    if (!acceptedDisclaimer) {
        return false;
    } else {
        analyticsService.submit(AnalyticsType.VISIT_BACK_TESTING);
        return true;
    }
}

async function ensureDisclaimerAccepted(milestoneStore: MilestoneStore, $uibModal: IModalService): Promise<boolean> {
    const milestones = await milestoneStore.current.take(1).toPromise();

    if (milestones.hasCompleted(Milestone.ACCEPTED_BACKTESTING_DISCLAIMER)) {
        return true;
    }

    const options = {
        size: "lg",
        backdrop: "static",
        templateUrl: "app/trade-simulator/components/disclaimer/Disclaimer.html"
    };
    const modalInstance = $uibModal.open(options);

    try {
        await modalInstance.result;
        await milestoneStore.completeMilestone(Milestone.ACCEPTED_BACKTESTING_DISCLAIMER);
        return true;
    } catch (e) {
        return false;
    }
}
